import CarteraServices from "../../services/CarteraServices";
const state = {
    loadingCartera: false,
    carteraPaging: [],
    paginationCartera: {
        descending: true,
        page: 1,
        rowsPerPage: 20,
        sortBy: 'sucursal',
        totalItems: 0,
        rowsPerPageItems: [10, 20, 50, 100]
    },
    provisionOptions: [        
        { value: "POR VENCER", title: "Por vencer (0 días)"},
        { value: "30", title: "30 días"},
        { value: "60", title: "60 días"},
        { value: "90", title: "90 días"},
        { value: "120", title: "120 días"},
        { value: "150", title: "150 días"},
        { value: "180", title: "180 días"},
        { value: "210", title: "210 días"},
        { value: "240", title: "240 días"},
        { value: "270", title: "270 días"},
        { value: "300", title: "300 días"},
        { value: "330", title: "330 días"},
        { value: "360", title: "360 días"},
        { value: "360 EN ADELANTE", title: "Mayor a 360 días"},
    ],
    carteraFileExcel: [],
};

const getters = {
    loadingCartera: state => {
        return state.loadingCartera;
    },
    carteraPaging: state => {
        return state.carteraPaging;
    },
    paginationCartera(state) {
        return state.paginationCartera
    },
    provisionOptions: state => {
        return state.provisionOptions;
    },
    carteraFileExcel: state => {
        return state.carteraFileExcel;
    }, 
};

const actions = {
    getCartera(context, filters) {
        context.commit("showLoadingCarteraIndicator");
        const {            
            page,
            rowsPerPage
        } = context.state.paginationCartera
        const profile = context.rootGetters.userProfile;

        filters.apsId = profile.user_id;
        filters.page = page;
        filters.rowsPerPage = rowsPerPage;

        return CarteraServices.getCartera(filters)
            .then((res) => {
                if (res.data.error == 0) {
                    const items = res.data.data.content;
                    const totalItems = res.data.data.total;
                    context.commit('_setCarteraPaging', {
                        items,
                        totalItems
                    })
                } else {
                    const items = [];
                    const totalItems = 0;
                    context.commit('_setCarteraPaging', {
                        items,
                        totalItems
                    })
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideLoadingCarteraIndicator");
            });
    },

    getCarteraExcel(context, filters) {        

        context.commit("showLoadingCarteraIndicator");        
        
        const profile = context.rootGetters.userProfile;

        filters.apsId = profile.user_id;      

        return CarteraServices.getCarteraExcel(filters)
            .then(res => {
                state.carteraFileExcel = res.data;
            })
            .finally(() => {
                context.commit("hideLoadingCarteraIndicator");
            });
    },

    getAgencias(context) {
        context.commit("showLoadingCarteraIndicator");
        return CarteraServices.getAgencias()
            .then((res) => {
                if (res.data.error == 0) {
                    return res.data.data;
                } else {
                    return [];
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideLoadingCarteraIndicator");
            });
    },

    getLineasNegocio(context) {
        context.commit("showLoadingCarteraIndicator");
        return CarteraServices.getLineasNegocio()
            .then((res) => {
                if (res.data.error == 0) {
                    return res.data.data;
                } else {
                    return [];
                }
            })
            .catch(() => {

            })
            .finally(() => {
                context.commit("hideLoadingCarteraIndicator");
            });
    },
};

const mutations = {
    showLoadingCarteraIndicator(state) {
        state.loadingCartera = true;
    },
    hideLoadingCarteraIndicator(state) {
        state.loadingCartera = false;
    },

    setPaginationCartera(state, payload) {
        state.paginationCartera = payload
    },
    _setCarteraPaging(state, {
        items,
        totalItems
    }) {
        state.carteraPaging = items
        state.paginationCartera.totalItems = totalItems
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};